(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/frejaeid/use-frejaeid-error-handling.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/frejaeid/use-frejaeid-error-handling.js');

'use strict';

const {
  dialog: dialogComp
} = svs.components;
const {
  logger
} = svs.playerLoginReact;
const {
  frejaeIdProgressStatus
} = svs.playerLoginReact.constants;
const {
  useUrlHelper
} = svs.playerLoginReact.sharedComponents;
const useFrejaeIdErrorHandling = () => {
  const {
    navigateToCancelUrl
  } = useUrlHelper();
  const handleShowFrejaeIdStatusCodeError = statusCode => {
    const title = 'Misslyckad inloggning';
    let statusMessage = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
    const {
      USER_DECLINED,
      SVS_DECLINED,
      CLIENT_TIMEOUT,
      DUPLICATED_AUTHTOKEN
    } = frejaeIdProgressStatus;
    switch (statusCode) {
      case CLIENT_TIMEOUT:
        return;
      case USER_DECLINED:
        break;
      case SVS_DECLINED:
        break;
      case DUPLICATED_AUTHTOKEN:
        statusMessage = 'För många samtidiga försök att logga in med Freja eID för samma användare, vänligen vänta en stund och försök igen.';
        break;
      default:
        logger.info('Unhandled login error, unknown Freja eId status code');
    }
    const dialog = new dialogComp.Confirm({
      branding: dialogComp.branding.TUR,
      icon: 'exclamation-sign',
      area: dialogComp.area.POPUP,
      type: dialogComp.type.ERROR,
      title,
      message: [{
        type: dialogComp.message.TEXT,
        text: statusMessage,
        align: dialogComp.message.align.CENTER
      }],
      actions: [{
        title: 'Okej',
        callback: () => {
          dialog.close();
          navigateToCancelUrl();
        }
      }]
    });
    dialogComp.api.add(dialog);
  };
  const handleShowFrejaeIdErrorCode = function (error, isLogin) {
    let doNavigateToCancelUrlAfterDialog = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const errorCode = error.code;
    const title = 'Misslyckad inloggning';
    let errorMessage = 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';
    switch (errorCode) {
      case 1:
        break;
      case 6: 
      case 31:
        errorMessage = 'För ytterligare information vänligen kontakta Svenska Spels kundservice på telefon 0770-11 11 11';
        break;
      case 22:
        errorMessage = 'Ups! Vår slagning mot Spelpaus.se för att se om du är spelpausad eller ej gav inget svar. Vänligen försök igen.' + ' Vid frågor, ring Svenska Spels Kundservice, 0770 - 11 11 11';
        break;
      default:
        {
          const type = isLogin ? 'login' : 'registration';
          logger.info("Unhandled ".concat(type, " error code: ").concat(errorCode), JSON.stringify(error));
        }
    }
    const dialog = new dialogComp.Confirm({
      branding: dialogComp.branding.TUR,
      icon: 'exclamation-sign',
      area: dialogComp.area.POPUP,
      type: dialogComp.type.ERROR,
      title,
      message: [{
        type: dialogComp.message.TEXT,
        text: errorMessage,
        align: dialogComp.message.align.CENTER
      }],
      actions: [{
        title: 'Okej',
        callback: () => {
          dialog.close();
          if (doNavigateToCancelUrlAfterDialog) {
            navigateToCancelUrl();
          }
        }
      }]
    });
    dialogComp.api.add(dialog);
  };
  return {
    handleShowFrejaeIdStatusCodeError,
    handleShowFrejaeIdErrorCode
  };
};
svs.playerLoginReact.frejaeid.useFrejaeIdErrorHandling = useFrejaeIdErrorHandling;

 })(window);